module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.982 12a1.991 1.991 0 0 0-.568-1.414l-10-10A1.974 1.974 0 0 0 20 .02V0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V12h-.018zM28 28H4V4h14v8c0 1.106.894 2 2 2h8v14zM16.292 14.302a1 1 0 0 0-1.414-.006l-4.466 4.466-2.7-2.554c-.866-.866-1.712-.58-1.712.646V24.6c0 .612.788 1.4 1.4 1.4h7.748c1.222 0 1.514-.848.648-1.71l-2.556-2.63 4.466-4.502c.39-.39.39-1.042 0-1.434l-1.414-1.422z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/turn-page-down-1.js
// module id = 1461
// module chunks = 14